// commonStyles.js
const CommonTextFieldProps = {
  size: "small",
  InputProps: {
    sx: { height: 26, fontSize: 12, backgroundColor: "#fff" },
  },
};

export default CommonTextFieldProps;